export default __webpack_public_path__ + "static/media/bra-arte-10.f75cf4de.webp";